import type { ComponentType, SVGProps } from "react";
import { ToggleGroup } from "@design-system/ToggleGroup/ToggleGroup";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { BoardViewIcon, ListViewIcon } from "@icons";
import type { BoardLayout } from "./boardLayoutCache";

interface LayoutOption {
    value: BoardLayout;
    label: string;
    Icon: ComponentType<SVGProps<SVGSVGElement>>;
}

const LAYOUT_OPTIONS: readonly LayoutOption[] = [
    { value: "list", label: "List view", Icon: ListViewIcon },
    { value: "board", label: "Board view", Icon: BoardViewIcon },
];

interface BoardLayoutToggleProps {
    layout: BoardLayout;
    onLayoutChange: (layout: BoardLayout) => void;
}

/** Switches a page between List and Board. */
export const BoardLayoutToggle = ({
    layout,
    onLayoutChange,
}: Readonly<BoardLayoutToggleProps>) => (
    <ToggleGroup.Root<BoardLayout>
        value={layout}
        onValueChange={(value) => value && onLayoutChange(value)}
        variant="button"
        aria-label="Layout"
    >
        {LAYOUT_OPTIONS.map(({ value, label, Icon }) => (
            <Tooltip key={value} content={label}>
                <ToggleGroup.Item value={value} aria-label={label}>
                    <Icon aria-hidden />
                </ToggleGroup.Item>
            </Tooltip>
        ))}
    </ToggleGroup.Root>
);
